export enum GarageActions {
  ShipCar = "Ship Car",
  ListOnMarket = "List on Market",
  Transfer = "Transfer",
}

export enum CarLabel {
  Race = "Race",
  OC = "OC",
  Crush = "Crush",
}
